import { EventEmitter, inject,Injectable } from '@angular/core';
import { HttpService, Search } from '@docpath/linces-angular-components/common';

import { EndPoints } from '../../../../constants/end-points';
import { FailedJobsResult } from '../models/failed-jobs-result';
import { NotificationPartial } from '../models/notification';

@Injectable({
    providedIn: 'root'
})
export class FailedJobsHttpService {
    readonly relativeUrl = `${EndPoints.ENDPOINT_WEB_API}/${EndPoints.ENDPOINT_CONFIGURATION}/${EndPoints.ENDPOINT_CONFIGURATION_FAILED_JOBS_NOTIFICATIONS}`;
    private readonly toastPrefix = 'failed-jobs.toast';

    showLoadingChanged: EventEmitter<boolean> = new EventEmitter();

    private readonly httpService = inject(HttpService);

    getNotifications(search: Search, suscribe: (result: FailedJobsResult, totalSize: number) => void): void {
        const searchBase64 = btoa(JSON.stringify(search));
        this.showLoadingChanged.emit(true);

        this.httpService.get({
            relativeUrl: this.relativeUrl,
            queryParameters: { search: searchBase64 },
            suscribe: response => {
                const responseBody = response.result as unknown as Search,
                    result = responseBody.result as FailedJobsResult,
                    totalSize = responseBody.paginator?.totalSize ?? 0;
                this.showLoadingChanged.emit(false);
                suscribe(result, totalSize);
            },
            suscribeOnError: () => {
                this.showLoadingChanged.emit(false);
            }
        });
    }

    editNotification(failedJob: NotificationPartial, suscribe: () => void): void {
        this.httpService.put(failedJob, {
            relativeUrl: this.relativeUrl,
            loading: true,
            suscribe,
            toast: `${this.toastPrefix}.update-success`
        });
    }

    deleteNotifications(failedJobsIds: number[], suscribe: () => void): void {
        this.httpService.delete({
            relativeUrl: `${this.relativeUrl}`,
            queryParameters: { ids: failedJobsIds },
            loading: true,
            suscribe,
            toast: `${this.toastPrefix}.delete-success`
        });
    }


    createNotification(notification: NotificationPartial, suscribe: () => void): void {
        this.httpService.post(notification, {
            relativeUrl: this.relativeUrl,
            loading: true,
            suscribe,
            toast: `${this.toastPrefix}.create-success`
        });
    }
}